import { Injectable } from '@angular/core';
import { APP_CONFIG } from 'app.config';
import { HttpHelper } from 'app/shared/common/utils/http/HttpHelper';
import { catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuickCreateAppBubbleButtonService {
  private _baseUrl = APP_CONFIG.MCR_XPSECMT + 'init'
  constructor(private _httpHelper: HttpHelper) { }

  public quickInitApp(payload: any, url?: string) {
    url = url || this._baseUrl + '/app';
    return this._httpHelper.methodPostObservableService(url, payload).pipe(catchError(err => {
      return throwError(() => new Error(`An error occurred: ${err.message}`));
    }));
  }
}
